import type { ReactNode } from "react"
import parse from "html-react-parser"
import searchIcon from "images/web/browse/search.svg?raw"
import boxIcon from "images/web/empty_states/empty_box.svg?raw"
import appletIcon from "images/web/empty_states/applet.svg?raw"
import archiveIcon from "images/web/empty_states/archive.svg?raw"

const ICONS: Record<string, string> = {
  mag: searchIcon,
  box: boxIcon,
  applet: appletIcon,
  archive: archiveIcon,
}

interface Props {
  heading: string
  copy: ReactNode
  cta?: string
  ctaUrl?: string
  onCtaClick?: () => void
  illustration?: string
  extraClass?: string
}

const EmptyStateCta = ({ heading, copy, cta, ctaUrl, onCtaClick, illustration = "mag", extraClass }: Props) => (
  <div className={`empty-state-container ${extraClass || ""}`}>
    <div className="illustration" aria-hidden="true" data-illustration={ICONS[illustration] ? illustration : "mag"}>
      {parse(ICONS[illustration] || searchIcon)}
    </div>
    <div className="txt">
      <h2 className="text-h3">{heading}</h2>
      <p className="body-small">{copy}</p>
    </div>
    {cta && ctaUrl && (
      <a href={ctaUrl} className="button-secondary">
        {cta}
      </a>
    )}
    {cta && !ctaUrl && onCtaClick && (
      <button type="button" className="button-secondary" onClick={onCtaClick}>
        {cta}
      </button>
    )}
  </div>
)

export default EmptyStateCta
